<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpuWireframe from '@/vcs/_shared/cpu-wireframe/cmp.vue'
import { XIcon } from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  extends: BaseModal,
  components: { XIcon, CpuWireframe },
  data: function () {
    return {
      selectedCpu: null,
      selectedBox: null
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    this.selectedCpu = this.cp.units.filter((cpu) => {
      return _.map(cpu.boxes, 'id').indexOf(this.data.boxId) != -1
    })[0]
  },
  methods: {
    calculateCpHeight(cp) {
      if (cp.dimensions) {
        return parseInt(cp.dimensions.split(',')[1])
      }
    },
    onBoxSelected(box) {
      this.selectedBox = box
      this.close(box)
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close()")
  .modal-body
    h1.page__header {{ $t('support.collectomate.supportBoxSelectModal.header') }}
    .row
      .col-12
        .selected-cpu(v-if="cp && data.cpu")
          cpu-wireframe(
            v-if="!!data.cpu"
            :cpu="data.cpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="500"
            :openedBoxId="(selectedBox || {}).id || ''"
            :isSelected="true"
            @box-selected="onBoxSelected($event)"
          )
</template>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.cpu-thumbnails {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.selected-cpu {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
